// extracted by mini-css-extract-plugin
export default {"v-asphalt":"#D8D8D8","v-hackster":"#2E9FE6","container":"hckui__nav-tabbed__container","tab":"hckui__nav-tabbed__tab","active":"hckui__nav-tabbed__active"};